import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';
import localforage from 'localforage';
import { modules } from './modules'




var main = modules.filter(module => module.name ==='main')[0];
var booking = modules.filter(module => module.name ==='booking')[0];

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
    key: 'Carloc',
    storage: localforage,
    reducer: (state) => ({
        [booking.name]: booking.persistReducer(state[booking.name]),
        [main.name]: main.persistReducer(state[main.name]),
    }),
    asyncStorage: true
});

export default new Vuex.Store({
    modules: {
        [booking.name]: booking.store,
        [main.name]: main.store,
    },
    plugins: [vuexLocal.plugin]
});


/*
const stores = loadStoreModules();
console.log("stores",stores);

const vuexLocal = new VuexPersistence({
    key: 'Carloc',
    storage: localforage,
    reducer: (state) => ({stores.reducer}),

    asyncStorage: true
});

export default new Vuex.Store({
    modules: stores.modules,
    plugins: [vuexLocal.plugin]
})
*/

/* TODO , when starting using s, uncomment this part
//import {loadStores} from '@/s';
const store = loadStores();

const vuexLocal = new VuexPersistence({
  key: 'Carloc',
  storage: localforage,
  s: store.persists,
  asyncStorage: true
});

export default new Vuex.Store({
  s: store.s,
  plugins: [vuexLocal.plugin]
})
*/
